module.exports = __webpack_public_path__ + "img/ServicioMineria.d903cfd8.png";